import script from "./AudienceManagementHeaderTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceManagementHeaderTable.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceManagementHeaderTable.vue?vue&type=style&index=0&id=ba53d564&lang=scss"

const __exports__ = script;

export default __exports__